module.exports = __webpack_public_path__ + "static/media/Coda Group_Logotyp-05.57d8b889.png";